import * as React from 'react';

import { RefTarget } from '@shared-ui/ref-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { InquiryProminence } from 'src/common/__generated__/api';
import { SharedUiContactHostWrapper } from '../shared-ui/offers/contact-host-wrapper';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';

export const PropertyContactHostWrapper: React.FC = () => (
  <UitkSpacing margin={{ block: 'six' }}>
    <RefTarget name="ContactHost" tabIndex={0}>
      <SimpleLazyLoadWrapper>
        <SharedUiContactHostWrapper prominence={InquiryProminence.MEDIUM}></SharedUiContactHostWrapper>
      </SimpleLazyLoadWrapper>
    </RefTarget>
  </UitkSpacing>
);
